import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(org)/o/$orgSlug/members")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/o/$orgSlug/settings",
      params: { orgSlug: params.orgSlug },
      search: { tab: "members" },
    });
  },
});
